import React, { useEffect } from "react";
import "./FloatingButtons.css";
import { FaComments, FaPhoneAlt } from "react-icons/fa";
import WhatsAppImg from "../Image/whatsapp/dentaswhtaspplogoo.png";

const FloatingButtons = () => {
 useEffect(() => {
  if (document.getElementById("tawk-chat-script")) return;

  window.Tawk_API = window.Tawk_API || {};
  window.Tawk_LoadStart = new Date();

  window.Tawk_API.onLoad = function () {
    // 🔥 Hide default widget completely
    window.Tawk_API.hideWidget();
  };

  const script = document.createElement("script");
  script.id = "tawk-chat-script";
  script.async = true;
  script.src = "https://embed.tawk.to/695fa57e73ebb51980333a9a/1jeepstq9";
  script.charset = "UTF-8";
  script.setAttribute("crossorigin", "*");

  document.body.appendChild(script);
}, []);


  const openChat = () => {
    if (window.Tawk_API && window.Tawk_API.maximize) {
      window.Tawk_API.maximize();
    } else {
      console.warn("Tawk.to is still loading...");
    }
  };

  return (
    <>
      {/* LEFT – CALL BUTTON */}
      <div className="floating-container position-left call-top mobile-left show">
        <a href="tel:9899811123" className="floating-btn call-btn">
          <FaPhoneAlt className="float-icon" />
        </a>
      </div>

      {/* LEFT – WHATSAPP BUTTON */}
      <div className="floating-container position-left mobile-left show">
        <a
          href="https://wa.me/9899811123"
          target="_blank"
          rel="noreferrer"
          className="floating-btn whatsapp-btn"
        >
          <img
            src={WhatsAppImg}
            alt="WhatsApp Chat"
            className="whatsapp-image"
          />
        </a>
      </div>

      {/* RIGHT – LIVE CHAT BUTTON (TAWK.TO) */}
      <div className="floating-container position-right">
        <button
          type="button"
          className="floating-btn chat-btn"
          onClick={openChat}
        >
          <FaComments className="float-icon" />
          <span className="hover-text">Live Support</span>
        </button>
      </div>
    </>
  );
};

export default FloatingButtons;
